import { HelperResult } from '@openclassrooms/sdk-web';
import { TimeAvailability } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useUpdate: useUpdateTimeAvailability, useGet: useGetTimeAvailability } = getCRUDHooks({
  entityName: 'timeAvailability',
  update: (values, { userId, context }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .timeAvailability.update('', values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  get: ({ userId }): HelperResult<TimeAvailability> =>
    clientApi.getOCClient().helpers.user.users.id(userId).timeAvailability.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useUpdateTimeAvailability, useGetTimeAvailability };
